import { render, staticRenderFns } from "./setChoosePicByVoice.vue?vue&type=template&id=acfab456&scoped=true"
import script from "./setChoosePicByVoice.vue?vue&type=script&lang=js"
export * from "./setChoosePicByVoice.vue?vue&type=script&lang=js"
import style0 from "./setChoosePicByVoice.vue?vue&type=style&index=0&id=acfab456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfab456",
  null
  
)

export default component.exports